var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "upload-svg",
    d: "M8.923 25.24c.51 0 .923.413.923.923v3.559c0 .252.204.456.456.456h19.396a.455.455 0 0 0 .456-.468v-3.522A.923.923 0 0 1 32 26.163v3.534A2.314 2.314 0 0 1 29.698 32H10.302A2.314 2.314 0 0 1 8 29.685v-3.522c0-.51.413-.923.923-.923zM19.502 8.124a.923.923 0 0 1 1.384.8v14.358l3.963-3.965a.923.923 0 1 1 1.305 1.305l-5.539 5.541a.923.923 0 0 1-.652.222l-.125-.008a.8.8 0 0 1-.441-.214h-.086l-5.465-5.467a.924.924 0 0 1 1.305-1.306l3.889 3.929V8.924c0-.33.176-.635.462-.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "upload-svg-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#upload-svg"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 40)",
    xlinkHref: "#upload-svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1cba34ca648ec5e007bd129ed481f3a2.svg";
export { ForwardRef as ReactComponent };